import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const FlipIcon = (props: SvgIconProps) => (
  <SvgIcon
    width="21"
    height="18"
    viewBox="0 0 21 18"
    sx={{ fill: 'none' }}
    {...props}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_13637_3156)">
      <path
        d="M2.04883 8.17002C2.89791 4.0647 6.24431 1 10.2431 1C13.0463 1 15.5288 2.50592 17.0552 4.82058"
        stroke="white"
        strokeLinecap="round"
      />
      <path
        d="M15.2212 5.97874L18.9434 4.16797L18.1386 7.24461L15.2212 5.97874Z"
        fill="white"
        fillOpacity="0.2"
        stroke="white"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M17.9531 10.2187C17.104 14.324 13.7576 17.3887 9.75881 17.3887C6.9557 17.3887 4.47318 15.8827 2.94671 13.5681"
        stroke="white"
        strokeLinecap="round"
      />
      <path
        d="M4.78322 12.3821L1.08203 14.2354L1.85156 11.1497L4.78322 12.3821Z"
        fill="white"
        fillOpacity="0.2"
        stroke="white"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_13637_3156">
        <rect width="20" height="18" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </SvgIcon>
);
